import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { usePASClientAuth } from '../../context/PASClientAuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-eth`;

export default function EthPurchaseSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { token, loading } = usePASClientAuth();
  const [p, setP] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;
    if (!token) { navigate(`/pas/login?next=${encodeURIComponent(`/pas/eth/success?purchase_id=${params.get('purchase_id')}`)}`); return; }
    axios.post(`${API}/purchases/${params.get('purchase_id')}/confirm`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setP(r.data)).catch(e => setError(e.response?.data?.detail || 'Could not confirm purchase'));
  }, [token, loading, params, navigate]);

  const done = p?.status === 'completed';
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md w-full text-center" data-testid="eth-success-card">
        {!p && !error && <p className="text-slate-400">Confirming payment and sending ETH...</p>}
        {done && (<><CheckCircle className="w-14 h-14 text-emerald-400 mx-auto mb-3" /><p className="text-white text-xl font-bold" data-testid="eth-success-amount">{p.eth_amount} ETH sent</p>
          <p className="text-slate-400 text-xs mt-2 break-all">to {p.to_address}</p>
          <a href={p.explorer_url} target="_blank" rel="noreferrer" className="text-purple-400 text-sm mt-3 inline-block" data-testid="eth-success-etherscan">View on Etherscan</a></>)}
        {p && !done && (<><Clock className="w-14 h-14 text-amber-300 mx-auto mb-3" /><p className="text-white font-semibold" data-testid="eth-success-pending">Payment received — delivery {p.status.replace(/_/g, ' ')}</p>
          <p className="text-slate-400 text-sm mt-2">{p.error || 'Your ETH will be sent as soon as the Treasury Reserve Wallet confirms.'}</p></>)}
        {error && (<><XCircle className="w-14 h-14 text-red-400 mx-auto mb-3" /><p className="text-red-400" data-testid="eth-success-error">{error}</p></>)}
        <button onClick={() => navigate('/pas/banking')} className="mt-6 px-5 py-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg" data-testid="eth-success-continue-btn">Back to Banking &amp; Credit</button>
      </div>
    </div>
  );
}
